//core
import Vue from 'vue';
import App from './App.vue';
import VueFilter from 'vue-filter';
import VueGtag from 'vue-gtag';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { sync } from 'vuex-router-sync';
import './theme/element-variables.scss';
import './assets/scss/application.scss';
import ApiAlertMixin from "@/mixins/ApiAlertMixin";

//setting
import router from './router';
import store from './store';

// vee-validate
import {extend, localize} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import ja from 'vee-validate/dist/locale/ja.json'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize('ja', ja)

Vue.use(VueFilter);
Vue.use(VueGtag, { config: { id: process.env.VUE_APP_GA_ID } }, router);

sync(store, router);

document.body.appendChild(document.createElement('app'));

Sentry.init({
  Vue,
  dsn: 'https://7f15dd163f274ac6b38bd33d4ccf6e9b@o155170.ingest.sentry.io/6158561',
  environment: process.env.VUE_APP_ENV,
  allowUrls: [/(.*)\.gigbase\.jp/],
  ignoreErrors: ['NavigationDuplicated'],
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [/(.*)\.gigbase\.jp/]
    })
  ],
  release: 'gigbase-webapp@' + process.env.VUE_APP_GITHUB_SHA
});

const app = new Vue({
  el: '#app',
  render: h => h(App),
  router: router,
  store: store,
  mixins: [ApiAlertMixin],
  provide: {
    store
  }
});
